import { Button, Checkbox, Input } from 'antd';
import React, { useState } from 'react';

type Option = { text: string; value: React.Key };

type FilterDropdownProps = {
  options?: Option[];
  setSelectedKeys: (keys: React.Key[]) => void;
  selectedKeys?: React.Key[];
  confirm: () => void;
  clearFilters?: () => void;
};

const FilterDropdown: React.FC<FilterDropdownProps> = ({
  options,
  setSelectedKeys,
  selectedKeys,
  confirm,
  clearFilters,
}) => {
  const [
    search,
    setSearch,
  ] = useState('');

  const visibleOptions = (options || []).filter((option) => option.text.toLowerCase().includes(search.toLowerCase()));
  const visibleValues = visibleOptions.map((option) => option.value);

  const allVisibleSelected = visibleValues.length > 0 && visibleValues.every((v) => (selectedKeys || []).includes(v));
  const someVisibleSelected = visibleValues.some((v) => (selectedKeys || []).includes(v));

  const toggleSelectAllVisible = (checked: boolean) => {
    if (checked) {
      const next = Array.from(
        new Set([
          ...(selectedKeys || []),
          ...visibleValues,
        ])
      );
      setSelectedKeys(next);
    } else {
      const next = (selectedKeys || []).filter((k) => !visibleValues.includes(k));
      setSelectedKeys(next);
    }
  };

  const toggleValue = (value: string, checked: boolean) => {
    const keys = new Set(selectedKeys || []);
    if (checked) {
      keys.add(value);
    } else {
      keys.delete(value);
    }
    setSelectedKeys([...keys]);
  };

  return (
    <div style={{ padding: 8, maxWidth: 300 }}>
      <Input
        placeholder="Search"
        value={search}
        onChange={(e) => setSearch(e.target.value)}
        style={{ marginBottom: 8 }}
      />
      <div style={{ display: 'flex', alignItems: 'center', marginBottom: 8 }}>
        <Checkbox
          indeterminate={!allVisibleSelected && someVisibleSelected}
          checked={allVisibleSelected}
          onChange={(e) => toggleSelectAllVisible(e.target.checked)}
        >
          Select all
        </Checkbox>
        <div style={{ flex: 1 }} />
      </div>
      <div style={{ maxHeight: 220, overflowY: 'auto', paddingRight: 8 }}>
        {visibleOptions.map((opt: any) => (
          <div key={opt.value} style={{ padding: '4px 0' }}>
            <Checkbox
              checked={(selectedKeys || []).includes(opt.value)}
              onChange={(e) => toggleValue(opt.value as string, e.target.checked)}
            >
              {opt.text}
            </Checkbox>
          </div>
        ))}
        {visibleOptions.length === 0 && <div style={{ color: '#999' }}>No matches</div>}
      </div>
      <div style={{ display: 'flex', justifyContent: 'flex-end', marginTop: 8 }}>
        <Button
          size="small"
          onClick={() => {
            if (clearFilters) clearFilters();
            setSearch('');
            confirm();
          }}
          style={{ marginRight: 8 }}
          disabled={(selectedKeys || []).length === 0}
        >
          Reset
        </Button>
        <Button
          type="primary"
          size="small"
          onClick={() => {
            confirm();
          }}
        >
          Apply
        </Button>
      </div>
    </div>
  );
};

export default FilterDropdown;
